module.exports = __webpack_public_path__ + "files/d6014ee68e32b68c27d853075c2781d7.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon_WS.png
// module id = 1298
// module chunks = 60